document.addEventListener('DOMContentLoaded', () => {
  const videoBoxes = document.querySelectorAll('.video-box');

  if (!videoBoxes.length) return;

  videoBoxes.forEach(box => {
    const playBtn = box.querySelector('.vb-play-btn');
    const loader = box.querySelector('.vb-loader');

    if (!playBtn || !loader) return;

    playBtn.addEventListener('click', () => {
      const src = box.dataset.video;

      if (!src) return;

      playBtn.style.display = 'none';
      loader.style.display = 'block';

      const video = document.createElement('video');
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.src = src;

      video.addEventListener('canplay', () => {
        loader.style.display = 'none';
        box.classList.add('vb-ready');

        if (!video.parentNode) {
          box.appendChild(video);
        }

        video.play().catch(() => {});
      });

      video.addEventListener('error', () => {
        loader.style.display = 'none';
        playBtn.style.display = 'block';
      });

      video.load();
    });
  });
});